import React, {useCallback, useEffect, useState} from "react";
import Item from "./Item";
import lien from './lien'
import './css/dash.scss'

export default function Form(props) {
    const [titre, setTitre] = useState("");
    const [messageErrorDescription, setMessageErrorDescription] = useState("");
    const [messageErrorTitre, setMessageErrorTitre] = useState("");
    const [valueInputDescription, setDescription] = useState("");
    const [idVal, setId] = useState(-1);
    const [listItem, setListItem] = useState([]);
    const [loading, setLoading] = useState(false);
    const [file, setFile] = useState(null);
    const [uploadStatus, setUploadStatus] = useState("");

    // Gestion du fichier
    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
            setUploadStatus("");
        }
    };

    const handleUpload = async () => {
        if (!file) {
            setUploadStatus("Veuillez sélectionner un fichier");
            return;
        }

        setUploadStatus("Téléchargement en cours...");

        try {
            const formData = new FormData();
            formData.append("file", file);

            const result = await fetch(`${lien.url}todos/upload`, {
                method: "POST",
                body: formData,
            });

            if (!result.ok) {
                throw new Error(`Erreur: ${result.status}`);
            }

            const data = await result.json();
            setUploadStatus("Fichier téléchargé avec succès");
            console.log(data);
        } catch (error) {
            console.error(error);
            setUploadStatus("Erreur lors du téléchargement");
        }
    };

    // Animation de chargement
    const startLoading = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 500);
    };

    useEffect(() => {
        startLoading();
    }, []);

    // Recherche d'éléments
    const recherche = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const items = await fetchAPI();

            if (titre === "" && valueInputDescription === "") {
                // Pas de filtre si aucun critère de recherche
                setListItem(items);
            } else {
                // Filtrer les résultats
                const filteredItems = items.filter(item =>
                    (titre && item.title.toLowerCase().includes(titre.toLowerCase())) ||
                    (valueInputDescription && item.description.toLowerCase().includes(valueInputDescription.toLowerCase()))
                );
                setListItem(filteredItems);
            }
        } catch (error) {
            console.error("Erreur lors de la recherche:", error);
        } finally {
            setLoading(false);
        }
    };

    // Récupération des données
    const fetchAPI = useCallback(async () => {
        try {
            const idUser = parseInt(localStorage.getItem("utilisateur") || "0");
            const token = localStorage.getItem('jwt') || "";

            if (!idUser || !token) {
                return [];
            }

            const response = await fetch(
                `${lien.url}todos/byuser/${idUser}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`Erreur: ${response.status}`);
            }

            const data = await response.json();
            setListItem(data);
            return data;
        } catch (error) {
            console.error("Erreur lors de la récupération des données:", error);
            return [];
        }
    }, []);

    // Fonction de suppression
    const handleDelete = async (e, id) => {
        e.preventDefault();
        setLoading(true);

        try {
            await fetchDelete(id);
        } finally {
            setLoading(false);
        }
    };

    // Remontée d'informations
    const updateId = (id) => setId(id);
    const updateTitle = (text) => setTitre(text);
    const updateDescription = (text) => setDescription(text);

    // Appel API au chargement
    useEffect(() => {
        if (localStorage.getItem('jwt')) {
            fetchAPI();
        }
    }, [fetchAPI]);

    // Suppression d'un élément
    const fetchDelete = useCallback(async (id) => {
        try {
            const idTodo = parseInt(id, 10);
            const token = localStorage.getItem('jwt') || "";

            const response = await fetch(
                `${lien.url}todos/${idTodo}`,
                {
                    method: "DELETE",
                    body: JSON.stringify({
                        jwt: token
                    }),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`Erreur: ${response.status}`);
            }

            await fetchAPI();
        } catch (error) {
            console.error("Erreur lors de la suppression:", error);
        }
    }, [fetchAPI]);

    // Création d'un élément
    const handleCreate = useCallback(async (e) => {
        e.preventDefault();

        if (!titre) {
            setMessageErrorTitre("Le titre est obligatoire");
            return;
        }

        setLoading(true);

        try {
            const userId = parseInt(localStorage.getItem("utilisateur") || "0");
            const token = localStorage.getItem('jwt') || "";

            const response = await fetch(
                `${lien.url}todos`,
                {
                    method: "POST",
                    body: JSON.stringify({
                        title: titre,
                        description: valueInputDescription,
                        user: userId,
                        isPublish: false,
                        numberLike: 0,
                        numberDisLike: 0,
                        pictureName: file?.name || "",
                        jwt: token
                    }),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`Erreur: ${response.status}`);
            }

            // Réinitialiser le formulaire après création
            setTitre("");
            setDescription("");
            await fetchAPI();

            if (file) {
                await handleUpload();
            }
        } catch (error) {
            console.error("Erreur lors de la création:", error);
        } finally {
            setLoading(false);
        }
    }, [titre, valueInputDescription, file, fetchAPI, handleUpload]);

    // Mise à jour d'un élément
    const handleUpdate = useCallback(async (e) => {
        e.preventDefault();

        if (idVal === -1) {
            setMessageErrorTitre("Veuillez sélectionner un élément à modifier");
            return;
        }

        setLoading(true);

        try {
            const userId = parseInt(localStorage.getItem("utilisateur") || "0");
            const token = localStorage.getItem('jwt') || "";

            const response = await fetch(
                `${lien.url}todos/${idVal}`,
                {
                    method: "PUT",
                    body: JSON.stringify({
                        title: titre,
                        description: valueInputDescription,
                        user: userId,
                        jwt: token,
                        pictureName: file?.name || ""
                    }),
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (!response.ok) {
                throw new Error(`Erreur: ${response.status}`);
            }

            // Réinitialiser le formulaire après mise à jour
            setTitre("");
            setDescription("");
            setId(-1);
            await fetchAPI();

            if (file) {
                await handleUpload();
            }
        } catch (error) {
            console.error("Erreur lors de la mise à jour:", error);
        } finally {
            setLoading(false);
        }
    }, [idVal, titre, valueInputDescription, file, fetchAPI, handleUpload]);

    // Gestion des changements de valeur
    const handleTitleChange = (e) => {
        const value = e.target.value;
        setTitre(value);

        if (value.length > 20) {
            setMessageErrorTitre("Le titre ne doit pas dépasser 20 caractères");
        } else {
            setMessageErrorTitre("");
        }
    };

    const handleDescriptionChange = (e) => {
        setDescription(e.target.value);
    };

    // Vérification de l'authentification
    if (!localStorage.getItem('jwt')) {
        return <p className="auth-error">Veuillez vous connecter pour accéder à cette page.</p>;
    }

    return (
        <div className="form-container">
            <div className="form-content">
                <div className="upload-section">
                    <div className="file-input-container">
                        <label htmlFor="file" className="file-label">Choisir un fichier</label>
                        <input id="file" type="file" onChange={handleFileChange} className="file-input" />
                    </div>

                    {file && (
                        <div className="file-details">
                            <h3>Détails du fichier:</h3>
                            <ul>
                                <li><strong>Nom:</strong> {file.name}</li>
                                <li><strong>Type:</strong> {file.type || "Non spécifié"}</li>
                                <li><strong>Taille:</strong> {(file.size / 1024).toFixed(2)} KB</li>
                            </ul>
                            <button onClick={handleUpload} className="upload-button">
                                Télécharger le fichier
                            </button>
                        </div>
                    )}

                    {uploadStatus && (
                        <p className={uploadStatus.includes("succès") ? "success-message" : "error-message"}>
                            {uploadStatus}
                        </p>
                    )}
                </div>

                <div className="form-fields">
                    <div className="form-group">
                        <label htmlFor="title">Titre</label>
                        <input
                            id="title"
                            placeholder="Titre"
                            value={titre}
                            onChange={handleTitleChange}
                            className={messageErrorTitre ? "input-error" : ""}
                        />
                        {messageErrorTitre && <p className="error-message">{messageErrorTitre}</p>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="description">Description</label>
                        <textarea
                            id="description"
                            placeholder="Description"
                            value={valueInputDescription}
                            onChange={handleDescriptionChange}
                            className={messageErrorDescription ? "input-error" : ""}
                        />
                        {messageErrorDescription && <p className="error-message">{messageErrorDescription}</p>}
                    </div>

                    <div className="form-actions">
                        <button onClick={handleUpdate} className="update-button">
                            Modifier
                        </button>
                        <button onClick={handleCreate} className="create-button">
                            Créer
                        </button>
                        <button onClick={recherche} className="search-button">
                            Rechercher
                        </button>
                    </div>
                </div>
            </div>

            <div className="items-container">
                {loading ? (
                    <div className="loading-indicator">
                        <h2>Chargement...</h2>
                    </div>
                ) : listItem.length > 0 ? (
                    <div className="items-grid">
                        {listItem.map((item, index) => (
                            <Item
                                key={item.id}
                                del={handleDelete}
                                changeColor={() => {}}
                                changeDec={updateDescription}
                                changetext={updateTitle}
                                updatefunc={updateId}
                                title={item.title}
                                fileName={item?.pictureName}
                                description={item.description}
                                isPublish={item.isPublish}
                                id={item.id}
                                numeberlike={item.numberLike}
                                numeberDislike={item.numberDisLike}
                            />
                        ))}
                    </div>
                ) : (
                    <p className="no-items-message">Aucun élément à afficher</p>
                )}
            </div>
        </div>
    );
}